<template>
    <div class="sfz-father">
        <p class="nav-box">
            <span class="title">身份证</span>
            <span class="refresh" @click="getIdCard(true)">更新信息</span>
        </p>
        <div class="sfz-box-w">
            <div class="electronic-certificate-box sfz-box box-shadow">
                <p class="section" style="margin: -6px 0px 8px 0px">
                    <span class="label" style="font-size: 14.4px;width: 40px">姓 名</span>
                    <span class="content">{{ idCard.CZRKXM }}</span>
                </p>
                <div class="section-box">
                    <p class="section">
                        <span class="label" style="font-size: 14.4px;width: 40px">性 别</span>
                        <span class="content">{{ idCard.CZRKXB }}</span>
                    </p>
                    <p class="section">
                        <span class="label" style="font-size: 14.4px;width: 40px">民 族</span>
                        <span class="content">{{ idCard.CZRKMZ }}</span>
                    </p>
                </div>
                <p class="section">
                    <span class="label" style="font-size: 14.4px;width: 40px">出 生</span>
                    <span class="content">
					<span class="content">{{ idCard.year }}</span>
					<span class="label mg-r-10" style="font-size: 14.4px;width: 40px">年</span>
					<span class="content">{{ idCard.month }}</span>
					<span class="label mg-r-10" style="font-size: 14.4px;width: 40px">月</span>
					<span class="content">{{ idCard.day }}</span>
					<span class="label" style="font-size: 14.4px;width: 40px">日</span>
				</span>
                </p>
                <p class="section address-box">
                    <span class="label" style="font-size: 14.4px;width: 40px;margin: 0px 0px 14px 0px">地 址</span>
                    <span class="content">{{idCard.CZRKZZ}}</span>
                </p>
                <p class="section identity-box">
                    <span class="label" style="font-size: 14.4px;width: 90px">公民身份号码</span>
                    <span class="content">{{ idCard.CZRKGMSFHM }}</span>
                </p>
                <img class="photo" :src="`data:image/png;base64,${idCard.CZRKXP}`" alt="照片">
            </div>
            <div class="electronic-certificate-box sfz-box sfz-box-two box-shadow">
                <p class="issue-organ">{{idCard.CZRKQFJG}}</p>
                <p class="date">{{idCard.CZRKYXQXQSRQ}}-{{idCard.CZRKYXQXJZRQ}}</p>
            </div>
        </div>
        <div v-show="dataShow">
            <div class="btn-dzzz">
                <img @click="showQrCode" src="~@public/img/user/electronicCertificate/sfz_btn.png"/>
                <img @click="toRealAuthentication" src="~@public/img/user/electronicCertificate/sfz_btn2.png"/>
            </div>
            <van-dialog v-model="qrcodeShow" :showConfirmButton="false" class="dialog-demo sfz">
                <div class="dialog-main">
                    <h3>身份证二维码</h3>
                    <div class="ewm-w">
                        <img :src="qrcode">
                        <p>证照核验识别二维码</p>
                    </div>
                </div>
                <div class="btn-ewm" @click="qrcodeShow=false">确 认</div>
            </van-dialog>
            <van-dialog v-model="randomCodeShow" :showConfirmButton="false" class="dialog-demo sfz">
                <div class="dialog-main">
                    <h3>身份证随机码</h3>
                    <div class="ewm-w">
                        <span>{{ randomCode }}</span>
                    </div>
                </div>
                <div class="btn-ewm" @click="randomCodeShow=false">确 认</div>
            </van-dialog>
        </div>

        <!--<div style="text-align: center;margin-top: 3.5rem;">-->
        <!--<van-button @click="wangba" type="info">电子证件二维码</van-button>-->
        <!--</div>-->

        <!--<van-dialog v-model="show"  class="dialog-demo">-->
        <!--<p style="text-align: left;margin-top: 10px;padding-left: 15px">二维码信息：</p>-->
        <!--<div class="img-box">-->
        <!--<img :src="qrcode" style="width: 100%">-->
        <!--</div>-->
        <!--<p style="text-align: left;padding: 0 15px">1.该二维码仅限湖北省已开通身份证电子凭证核实业务的酒店使用</p>-->
        <!--<p style="text-align: left;margin-top: 5px;padding: 0 15px;margin-bottom: 20px">2.请入住前向前台出示本二维码</p>-->
        <!--</van-dialog>-->
    </div>
</template>

<script>

    import {Dialog, Toast, Button} from 'vant';
    import {queryApiMap} from "@/api/query";
    import {getToken} from "@/utils/auth"

    export default {
        components: {
            [Dialog.Component.name]: Dialog.Component,
            [Toast.name]: Toast,
            [Button.name]: Button,
        },
        data() {
            return {
                qrcodeShow: false,
                randomCodeShow: false,
                idCard: {},
                qrcode: '',
                randomCode: '',
                dataShow: false,
                userInfo: {}, // 存放cookie中获取的个人信息
            };
        },
        beforeRouteLeave(to, from, next) {
            if (to.path === '/sign-up/login' && this.$store.state.loginStatus) {
                next('/electronicCertificate')
            }
            next()
        },
        mounted() {
            //获取居民身份证信息
            this.getIdCard(false)
            this.getLoginInfo()
            this.logger.visit('703','1')
        },
        methods: {
            getQueryString(name,url) {
                return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(url) || [, ""])[1].replace(/\+/g, '%20')) || null
            },
            getLoginInfo:function (){
                if (this.$cookie.loginState()) {
                    this.userInfo = this.$cookie.getUser()
                }
            },
            showQrCode: function () {
                const data = {
                    permitType: '08' // 证照类型
                }
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '加载中...'
                })
                this.$httpUtils.getGatewayUtils(queryApiMap.qrcode, data).then(res => {
                    if (res.data.succ) {
                        this.qrcode = 'data:image/png;base64,' + res.data.data;
                        Toast.clear()
                        this.qrcodeShow = true
                    } else {
                        Toast.fail(res.data.msg)
                    }
                }).catch(error => {
                    // Toast.fail('服务器运行失败，请稍后再试。')
                    Toast.fail('服务停止运行，给您带来的不便进请原谅！')
                    console.log(error)

                })
            },
            /**
             * 跳转外部实人认证
             */
            async toRealAuthentication() {
                const token = getToken('access_token')
                if (!this.userInfo.guid || !token) {
                    Dialog.alert({
                        message: '请先登录'
                    })
                    return false
                }
                window.sessionStorage.setItem('operateType','getRandom')
                let redirect = this.$route.path
                window.location.href = `${global.realAuthenticationUrl}?token=${token}&redirect=${redirect}`
                window.sessionStorage.setItem('redirect',redirect)
            },
            showRandomCode() {
                const data = {
                    permitType: '08' // 证照类型
                }
                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '加载中...'
                })
                this.$httpUtils.getGatewayUtils(queryApiMap.randomCode, data).then(res => {
                    if (res.data.succ) {
                        this.randomCode = res.data.data;
                        Toast.clear()
                        this.randomCodeShow = true
                    } else {
                        Toast.fail(res.data.msg)
                    }
                }).catch(error => {
                    // Toast.fail('服务器运行失败，请稍后再试。')
                    Toast.fail('服务停止运行，给您带来的不便进请原谅！')
                    console.log(error)
                })
            },
            /**
             * 获取居民身份证信息
             */
            getIdCard(refresh) {
                const data = {
                    permitType: '08', // 证照类型
                    refresh: refresh // 是否刷新数据  true/false
                }

                Toast.loading({
                    duration: 0,       // 持续展示 toast
                    forbidClick: true, // 禁用背景点击
                    loadingType: 'spinner',
                    message: '加载中...'
                })

                this.$httpUtils.getGatewayUtils(queryApiMap.electronicPermit, data).then(res => {
                    if (res.data.succ) {
                        this.dataShow = true
                        const data = res.data.data
                        this.idCard = Object.assign({}, data.row)
                        const dateArr = this.idCard.CZRKCSRQ.split('-')
                        let dayArr = dateArr[dateArr.length - 1].split(' ')
                        this.idCard.year = dateArr[0]
                        this.idCard.month = dateArr[1]
                        this.idCard.day = dayArr[0]
                        if (this.idCard.CZRKYXQXQSRQ) {
                            this.idCard.CZRKYXQXQSRQ = this.idCard.CZRKYXQXQSRQ.substring(0, 4)+'.'+this.idCard.CZRKYXQXQSRQ.substring(5, 7)+'.'+this.idCard.CZRKYXQXQSRQ.substring(8, 10);
                        }
                        if (this.idCard.CZRKYXQXJZRQ) {
                            if(this.idCard.CZRKYXQXJZRQ.substring(0, 4) === '0000'){
                                this.idCard.CZRKYXQXJZRQ = '长期';
                            }else{
                                this.idCard.CZRKYXQXJZRQ = this.idCard.CZRKYXQXJZRQ.substring(0, 4)+'.'+this.idCard.CZRKYXQXJZRQ.substring(5, 7)+'.'+this.idCard.CZRKYXQXJZRQ.substring(8, 10);
                            }
                        }
                        Toast.clear()
                        if (this.getQueryString('operateType',window.location.href) === 'getRandom'){
                            this.showRandomCode()
                        }
                    } else {
                        Toast.fail(res.data.msg)
                    }
                }).catch(error => {
                    Toast.fail('服务停止运行，给您带来的不便进请原谅！')
                    // Toast.fail('服务器运行失败，请稍后再试。')
                    console.log(error)
                })
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@assets/css/views/user/electronicCertificate/reset.less";
    @import "~@assets/css/views/user/electronicCertificate/IdCard.less";
    /*.van-dialog{*/
    /*top:48%;*/
    /*width: 74%;*/
    /*}*/
    .refresh {
        flex: 1;
        color: #5bade7;
        text-align: right;
        cursor: pointer;
    }

</style>
